import moment from 'moment'
import i18n from '@/locales'

export const getStatusColumn = () => {
  return {
    field: 'cancelled',
    title: i18n.t('scope.text_798'),
    // sortable: true,
    minWidth: 100,
    slots: {
      default: ({ row }, h) => {
        let status = 'effective'
        if (row.cancelled) {
          status = 'cancel'
        } else if (moment().isAfter(row.expire)) {
          status = 'failure'
        }
        const statusObj = {
          effective: i18n.t('scope.text_799'),
          failure: i18n.t('scope.text_800'),
          cancel: i18n.t('scope.cancelled'),
        }
        const statusClass = {
          effective: '#52c41a',
          failure: 'red',
          cancel: '#9c9c9c',
        }
        return [
          <div style={{ color: statusClass[status] }}>{statusObj[status]}</div>,
        ]
      },
    },
  }
}
